import React, {useMemo, useCallback} from 'react';
import PropTypes from 'prop-types';
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper';
import {
  pointExpirationJsonSchema,
  pointExpirationUiSchema
} from '@/services/schema/activity';

const PointExpirationSetUp = ({formData, handleFormChange}) => {
  const memoizedHandleFormChange = useCallback(
    (data) => handleFormChange(data),
    [handleFormChange]
  );

  const previewValue = useMemo(
    () => formData.noOfDays || '0',
    [formData.noOfDays]
  );

  return (
    <div className='flex w-full flex-col' data-testid='point-expiration-setup'>
      <div className='min-w-[288px]'>
        <JsonFormsWrapper
          jsonschema={pointExpirationJsonSchema}
          uischema={pointExpirationUiSchema}
          data={formData}
          onChange={memoizedHandleFormChange}
        />
      </div>

      <div className='mt-2'>
        <div className='text-sm font-medium'>
          <span className='mr-1'>Preview:</span>
          <span className='preview-value'>
            Points expire after{' '}
            <span className='font-bold'>{previewValue}</span> days
          </span>
        </div>
      </div>
    </div>
  );
};

PointExpirationSetUp.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFormChange: PropTypes.func.isRequired
};

export default React.memo(PointExpirationSetUp);
